export default __webpack_public_path__ + "static/media/module-tender-hammer.2515e5ec.svg";